import { useQuery } from 'react-query';
import InAppNotificationsApi from 'app/api/inAppNotifications';
import { queryKey } from 'constants/queryKey';
import { ApiClientError } from 'api/client';
import { InAppNotificationsSummary } from 'types/InAppNotification';

const useInAppNotificationsSummaryQuery = () =>
  useQuery<InAppNotificationsSummary, ApiClientError>(
    queryKey.inAppNotificationsSummary(),
    InAppNotificationsApi.getSummary,
  );

export default useInAppNotificationsSummaryQuery;
